import { type FieldValues, type UseControllerProps, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { type IAdditionalFieldSelectProps } from '../AdditionalFieldSelect/AdditionalFieldSelect';
import { type LicenseFieldProps } from './LicenseFieldController';
import AdditionalFieldSelect from '../AdditionalFieldSelect';

import { useLicenseController } from '../../hooks/useLicenseController';

export const LicenseAdditionalFieldSelect = ({
  name,
  defaultValue,
  configName,
  featureFlag,
  viewMode,
  rules,
  shouldUnregister,
  control,
  disabled,
  ...rest
}: IAdditionalFieldSelectProps & LicenseFieldProps & UseControllerProps<FieldValues, any>) => {
  const { control: contextControl } = useFormContext();
  const { t } = useTranslation();

  const {
    field: { value, onChange, onBlur, ...fieldRest },
    computedProps,
    config,
  } = useLicenseController({
    name,
    configName,
    featureFlag,
    control: control ?? contextControl,
    defaultValue: defaultValue ?? null,
    rules,
    shouldUnregister,
    viewMode,
    disabled,
  });

  const handleChange: typeof rest.onChange = (...args) => {
    onChange(...args);

    if ('onChange' in rest && typeof rest.onChange === 'function') {
      rest.onChange(...args);
    }
  };

  const handleBlur: typeof rest.onBlur = (...args) => {
    onBlur();

    if ('onBlur' in rest && typeof rest.onBlur === 'function') {
      rest.onBlur(...args);
    }
  };

  if (config.isHidden) {
    return <></>;
  }

  return (
    <AdditionalFieldSelect
      {...fieldRest}
      {...computedProps}
      {...rest}
      loadingMessage={() => t('Loading...')}
      onChange={handleChange}
      onBlur={handleBlur}
    />
  );
};
